interface CheckboxOptionProps {
  id: string;
  name: string;
  value: string;
  label: string;
  description?: string;
  checked: boolean;
  onChange: (value: string, checked: boolean) => void;
}

export default function CheckboxOption({ id, name, value, label, description, checked, onChange }: CheckboxOptionProps) {
  return (
    <label
      htmlFor={id}
      className={`flex items-start p-4 border-2 rounded-lg cursor-pointer transition-smooth hover:border-primary/50 ${
        checked ? 'border-primary bg-primary/5' : 'border-border bg-card'
      }`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => onChange(value, e.target.checked)}
        className="mt-1 w-4 h-4 text-primary focus:ring-primary focus:ring-2 rounded"
      />
      <div className="ml-3 flex-1">
        <span className="block text-sm font-medium text-text-primary">{label}</span>
        {description && <span className="block text-xs text-text-secondary mt-1">{description}</span>}
      </div>
    </label>
  );
}